import { Participant } from '@/interfaces/Participant'

export const ParticipantDetail = ({ participant, title }: { participant: Participant; title: string }) => {
  if (!participant) return null
  const address = participant.address
  return (
    <div className="space-y-1.5 text-sm">
      <p className="text-xs text-muted-foreground">{title}</p>
      <p className="font-medium">{participant.name}</p>
      {address?.address && (
        <address className="not-italic text-muted-foreground">
          {address.address}
          <br />
          {address.zip} {address.city}
          {address.country && address.country !== 'CZ' ? `, ${address.country}` : ''}
        </address>
      )}
      <div className="space-y-0.5 text-muted-foreground tabular">
        {participant.ico && <p>IČO {participant.ico}</p>}
        {participant.dic && <p>DIČ {participant.dic}</p>}
        {participant.email && <p>{participant.email}</p>}
        {participant.phone && <p>{participant.phone}</p>}
      </div>
    </div>
  )
}
